import React, { useState } from 'react';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import { FaBriefcase, FaCheckCircle, FaEnvelope, FaPen, FaPhoneAlt, FaRegBuilding, FaRegFileAlt, FaRegUser, FaShieldAlt } from 'react-icons/fa';
import axios from 'axios';

const Form3f12 = () => {



    const [formStep, setFormStep] = useState(1);
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        phone: '',
        email: '',
        chiefPromoter: '',
        designation: '',
        yearOfIncorporation: '',
        areasOfOperation: '',
        attendAwards: '',
        willingToSupplement: '',
        willingToPresent: '',
        writeUp: '',
        otherInfo: '',
        legalCompliance: {
            statutoryApprovals: false,
            noPFTaxLiabilities: false,
            noOffences: false,
            notNPA: false,
            noChildEmployment: false,
        },
        applicantName: '',
        applicantDesignation: '',
        applicantEmail: '',
        applicantPhone: '',
        signature: '',
    });

    const [signatureFile, setSignatureFile] = useState(null);

    const handleSignatureChange = (e) => {
        setSignatureFile(e.target.files[0]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData({
            ...formData,
            legalCompliance: {
                ...formData.legalCompliance,
                [name]: checked ? 1 : 0,
            },
        });
    };

    const [form1_id, setForm1Id] = useState('');
    const [email, setForm1Email] = useState('');

    const handleSubmit1 = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('address', formData.address);
        formDataToSend.append('phone', formData.phone);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('chiefPromoter', formData.chiefPromoter);
        formDataToSend.append('designation', formData.designation);
        formDataToSend.append('yearOfIncorporation', formData.yearOfIncorporation);
        formDataToSend.append('areasOfOperation', formData.areasOfOperation);
        formDataToSend.append('attendAwards', formData.attendAwards);
        formDataToSend.append('willingToSupplement', formData.willingToSupplement);
        formDataToSend.append('willingToPresent', formData.willingToPresent);
        formDataToSend.append('writeUp', formData.writeUp);
        formDataToSend.append('otherInfo', formData.otherInfo);

        formDataToSend.append('statutoryApprovals', formData.legalCompliance.statutoryApprovals ? '1' : '0');
        formDataToSend.append('noPFTaxLiabilities', formData.legalCompliance.noPFTaxLiabilities ? '1' : '0');
        formDataToSend.append('noOffences', formData.legalCompliance.noOffences ? '1' : '0');
        formDataToSend.append('notNPA', formData.legalCompliance.notNPA ? '1' : '0');
        formDataToSend.append('noChildEmployment', formData.legalCompliance.noChildEmployment ? '1' : '0');

        formDataToSend.append('applicantName', formData.applicantName);
        formDataToSend.append('applicantDesignation', formData.applicantDesignation);
        formDataToSend.append('applicantEmail', formData.applicantEmail);
        formDataToSend.append('applicantPhone', formData.applicantPhone);

        if (signatureFile) {
            formDataToSend.append('signature', signatureFile);
        }

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/api-form1/submit', formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log(response.data);
            setForm1Id(response.data.form1_id);
            setForm1Email(response.data.email);
            setFormStep(2);
            alert('Form submitted successfully');
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Failed to submit form. Please try again.');
        }
    };


    //  ---------> form 2

    const [snapshotOfOrganisation, setSnapshotOfOrganisation] = useState('');
    const [vision, setVision] = useState('');
    const [achievementsOfOrganisation, setAchievementsOfOrganisation] = useState('');
    const [contributionToExchequer, setContributionToExchequer] = useState('');
    const [sizeOfOrganisationBelow10, setSizeOfOrganisationBelow10] = useState('');
    const [sizeOfOrganisation10to20, setSizeOfOrganisation10to20] = useState('');
    const [sizeOfOrganisation20to50, setSizeOfOrganisation20to50] = useState('');
    const [sizeOfOrganisationAbove50, setSizeOfOrganisationAbove50] = useState('');
    const [ownershipSoleProprietor, setOwnershipSoleProprietor] = useState(false);
    const [ownershipPartnershipFirm, setOwnershipPartnershipFirm] = useState(false);
    const [ownershipPrivateLimitedCompany, setOwnershipPrivateLimitedCompany] = useState(false);
    const [ownershipLimitedCompany, setOwnershipLimitedCompany] = useState(false);
    const [ownershipCooperativeSociety, setOwnershipCooperativeSociety] = useState(false);
    const [sectorPrivate, setSectorPrivate] = useState(false);
    const [sectorPublic, setSectorPublic] = useState(false);
    const [sectorGovernmentCentral, setSectorGovernmentCentral] = useState(false);
    const [sectorGovernmentState, setSectorGovernmentState] = useState(false);
    const [sectorOthers, setSectorOthers] = useState(false);
    const [noOfEmployeesLessThan20, setNoOfEmployeesLessThan20] = useState('');
    const [noOfEmployees20to50, setNoOfEmployees20to50] = useState('');
    const [noOfEmployees50to100, setNoOfEmployees50to100] = useState('');
    const [noOfEmployeesAbove100, setNoOfEmployeesAbove100] = useState('');
    const [financialResults2021_22, setFinancialResults2021_22] = useState('');
    const [financialResults2022_23, setFinancialResults2022_23] = useState('');
    const [financialResults2023_24, setFinancialResults2023_24] = useState('');

    const [main_products_services_description1, setMainProductsServicesDescription1] = useState('');
    const [main_products_services_capacity1, setMainProductsServicesCapacity1] = useState('');
    const [main_products_services_description2, setMainProductsServicesDescription2] = useState('');
    const [main_products_services_capacity2, setMainProductsServicesCapacity2] = useState('');
    const [main_products_services_description3, setMainProductsServicesDescription3] = useState('');
    const [main_products_services_capacity3, setMainProductsServicesCapacity3] = useState('');
    const [major_facilities_land_area, setMajorFacilitiesLandArea] = useState('');
    const [major_facilities_factory_built_up_area, setMajorFacilitiesFactoryBuiltUpArea] = useState('');
    const [major_facilities_major_equipment, setMajorFacilitiesMajorEquipment] = useState('');
    const [major_facilities_specialized_facility, setMajorFacilitiesSpecializedFacility] = useState('');
    const [major_facilities_services, setMajorFacilitiesServices] = useState('');
    const [technology_adopted_traditional, setTechnologyAdoptedTraditional] = useState(false);
    const [technology_adopted_indigenous, setTechnologyAdoptedIndigenous] = useState(false);
    const [technology_adopted_in_house_r_d, setTechnologyAdoptedInHouseRD] = useState(false);
    const [technology_adopted_foreign_technology, setTechnologyAdoptedForeignTechnology] = useState(false);
    const [technology_adopted_franchise, setTechnologyAdoptedFranchise] = useState(false);
    const [technology_adopted_comment, setTechnologyAdoptedComment] = useState('');
    const [quality_compliance_iso, setQualityComplianceIso] = useState(false);
    const [quality_compliance_bis, setQualityComplianceBis] = useState(false);
    const [quality_compliance_gmp_who_fda_haccp, setQualityComplianceGmpWhoFdaHaccp] = useState(false);
    const [quality_compliance_other, setQualityComplianceOther] = useState(false);
    const [quality_compliance_comment, setQualityComplianceComment] = useState('');
    const [management_functions_human_resources_department, setManagementFunctionsHumanResourcesDepartment] = useState(false);
    const [management_functions_finance_accounts, setManagementFunctionsFinanceAccounts] = useState(false);
    const [management_functions_marketing_business_development, setManagementFunctionsMarketingBusinessDevelopment] = useState(false);
    const [management_functions_r_d, setManagementFunctionsRD] = useState(false);
    const [management_functions_internal_audit, setManagementFunctionsInternalAudit] = useState(false);
    const [management_functions_quality_assurance, setManagementFunctionsQualityAssurance] = useState(false);
    const [management_functions_other, setManagementFunctionsOther] = useState(false);
    const [management_functions_comment, setManagementFunctionsComment] = useState('');
    const [level_of_it_intervention_use_of_erp, setLevelOfITInterventionUseOfERP] = useState(false);
    const [level_of_it_intervention_customized_software, setLevelOfITInterventionCustomizedSoftware] = useState(false);
    const [level_of_it_intervention_general_office_solutions, setLevelOfITInterventionGeneralOfficeSolutions] = useState(false);
    const [level_of_it_intervention_no_it_facility, setLevelOfITInterventionNoITFacility] = useState(false);
    const [level_of_it_intervention_comment, setLevelOfITInterventionComment] = useState('');
    const [award_recognition_yes, setAwardRecognitionYes] = useState(false);
    const [award_recognition_no, setAwardRecognitionNo] = useState(false);
    const [award_recognition_comment, setAwardRecognitionComment] = useState('');

    const [strategic_plan_for_future_yes, setStrategicPlanForFutureYes] = useState(false);
    const [strategic_plan_for_future_no, setStrategicPlanForFutureNo] = useState(false);
    const [strategic_plan_for_future_comment, setStrategicPlanForFutureComment] = useState('');

    const [about_product_service_description, setAboutProductServiceDescription] = useState('');
    const [about_product_service_capacity, setAboutProductServiceCapacity] = useState('');
    const [about_product_service_features, setAboutProductServiceFeatures] = useState('');
    const [about_product_service_uniqueness, setAboutProductServiceUniqueness] = useState('');
    const [about_product_service_market, setAboutProductServiceMarket] = useState('');
    const [about_product_service_export_content_in_turnover, setAboutProductServiceExportContentInTurnover] = useState('');

    const [about_chief_promoter_educational_qualification, setAboutChiefPromoterEducationalQualification] = useState('');
    const [about_chief_promoter_experience_in_line, setAboutChiefPromoterExperienceInLine] = useState('');
    const [about_chief_promoter_first_generation_entrepreneur, setAboutChiefPromoterFirstGenerationEntrepreneur] = useState('');
    const [about_chief_promoter_contribution_to_organisation, setAboutChiefPromoterContributionToOrganisation] = useState('');
    const [about_chief_promoter_relevant_details, setAboutChiefPromoterRelevantDetails] = useState('');

    const [signatureUrl, setSignatureUrl] = useState('');
    const [name, setName] = useState('');
    const [designation, setDesignation] = useState('');

    // Handle form submission
    const handleSubmit2 = async (e) => {
        e.preventDefault();

        const formData = {
            snapshot_of_organisation: snapshotOfOrganisation,
            vision: vision,
            achievements_of_organisation: achievementsOfOrganisation,
            contribution_to_exchequer: contributionToExchequer,
            size_of_organisation_below_10: sizeOfOrganisationBelow10,
            size_of_organisation_10_20: sizeOfOrganisation10to20,
            size_of_organisation_20_50: sizeOfOrganisation20to50,
            size_of_organisation_above_50: sizeOfOrganisationAbove50,
            ownership_sole_proprietor: ownershipSoleProprietor,
            ownership_partnership_firm: ownershipPartnershipFirm,
            ownership_private_limited_company: ownershipPrivateLimitedCompany,
            ownership_limited_company: ownershipLimitedCompany,
            ownership_cooperative_society: ownershipCooperativeSociety,
            sector_private: sectorPrivate,
            sector_public: sectorPublic,
            sector_government_central: sectorGovernmentCentral,
            sector_government_state: sectorGovernmentState,
            sector_others: sectorOthers,
            no_of_employees_less_than_20: noOfEmployeesLessThan20,
            no_of_employees_20_50: noOfEmployees20to50,
            no_of_employees_50_100: noOfEmployees50to100,
            no_of_employees_above_100: noOfEmployeesAbove100,
            financial_results_2021_22: financialResults2021_22,
            financial_results_2022_23: financialResults2022_23,
            financial_results_2023_24: financialResults2023_24,

            main_products_services_description1,
            main_products_services_capacity1,
            main_products_services_description2,
            main_products_services_capacity2,
            main_products_services_description3,
            main_products_services_capacity3,
            major_facilities_land_area,
            major_facilities_factory_built_up_area,
            major_facilities_major_equipment,
            major_facilities_specialized_facility,
            major_facilities_services,
            technology_adopted_traditional,
            technology_adopted_indigenous,
            technology_adopted_in_house_r_d,
            technology_adopted_foreign_technology,
            technology_adopted_franchise,
            technology_adopted_comment,
            quality_compliance_iso,
            quality_compliance_bis,
            quality_compliance_gmp_who_fda_haccp,
            quality_compliance_other,
            quality_compliance_comment,
            management_functions_human_resources_department,
            management_functions_finance_accounts,
            management_functions_r_d,
            management_functions_internal_audit,
            management_functions_quality_assurance,
            management_functions_other,
            management_functions_marketing_business_development,
            management_functions_comment,
            level_of_it_intervention_use_of_erp,
            level_of_it_intervention_customized_software,
            level_of_it_intervention_general_office_solutions,
            level_of_it_intervention_no_it_facility,
            level_of_it_intervention_comment,
            award_recognition_yes,
            award_recognition_no,
            award_recognition_comment,
            strategic_plan_for_future_yes,
            strategic_plan_for_future_no,
            strategic_plan_for_future_comment,
            about_product_service_description,
            about_product_service_capacity,
            about_product_service_features,
            about_product_service_uniqueness,
            about_product_service_market,
            about_product_service_export_content_in_turnover,
            about_chief_promoter_educational_qualification,
            about_chief_promoter_experience_in_line,
            about_chief_promoter_first_generation_entrepreneur,
            about_chief_promoter_contribution_to_organisation,
            about_chief_promoter_relevant_details,

            signature_url: signatureUrl,
            name,
            designation,
            form1_id: form1_id,
        };

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/submit-nomination', formData);
            alert('Data submitted successfully');
            setFormStep(3);
            console.log('respose Data', response);
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            alert('Error submitting form');
        }
    };

    /// form 3----------------->


    const [namek, setNamek] = useState('');
    const [designationk, setDesignationk] = useState('');
    const [age, setAge] = useState('');

    const [technicalPg, setTechnicalPg] = useState('');
    const [technicalGraduate, setTechnicalGraduate] = useState('');
    const [technicalOthers, setTechnicalOthers] = useState('');
    const [financialPg, setFinancialPg] = useState('');
    const [financialGraduate, setFinancialGraduate] = useState('');
    const [financialOthers, setFinancialOthers] = useState('');
    const [managementPg, setManagementPg] = useState('');
    const [managementGraduate, setManagementGraduate] = useState('');
    const [managementOthers, setManagementOthers] = useState('');
    const [professionalPg, setProfessionalPg] = useState('');
    const [professionalGraduate, setProfessionalGraduate] = useState('');
    const [professionalOthers, setProfessionalOthers] = useState('');
    const [otherToSpePg, setOtherToSpePg] = useState('');
    const [otherToSpeGraduate, setOtherToSpeGraduate] = useState('');
    const [otherToSpeOthers, setOtherToSpeOthers] = useState('');

    const [expTotalInYear, setExpTotalInYear] = useState('');
    const [expInSameLine, setExpInSameLine] = useState('');
    const [expInSameOrg, setExpInSameOrg] = useState('');
    const [isNomineeChiefPromoter, setIsNomineeChiefPromoter] = useState('');
    const [isNomineeFirstGeneration, setIsNomineeFirstGeneration] = useState('');
    const [business, setBusiness] = useState('');
    const [industry, setIndustry] = useState('');
    const [agriculture, setAgriculture] = useState('');
    const [service, setService] = useState('');
    const [other, setOther] = useState('');
    const [family_background, setFamilyBacgroumd] = useState('');

    const [traditional, setTraditional] = useState('');
    const [existing, setExisting] = useState('');
    const [innovative, setInnovative] = useState('');
    const [importSubstitute, setImportSubstitute] = useState('');
    const [product_Service, setProductService] = useState('');

    const [indigenous, setIndigenous] = useState('');
    const [ownRd, setOwnRd] = useState('');
    const [imported, setImported] = useState('');
    const [source_of_technology, setSourceOfTechnology] = useState('');

    const [investmentAtStart, setInvestmentAtStart] = useState('');
    const [termLoanAtStart, setTermLoanAtStart] = useState('');
    const [turnoverAtStart, setTurnoverAtStart] = useState('');
    const [pbtAtStart, setPbtAtStart] = useState('');
    const [manpowerAtStart, setManpowerAtStart] = useState('');
    const [exportsAtStart, setExportsAtStart] = useState('');
    const [investmentAtEnd, setInvestmentAtEnd] = useState('');
    const [termLoanAtEnd, setTermLoanAtEnd] = useState('');
    const [turnoverAtEnd, setTurnoverAtEnd] = useState('');
    const [pbtAtEnd, setPbtAtEnd] = useState('');
    const [manpowerAtEnd, setManpowerAtEnd] = useState('');
    const [exportsAtEnd, setExportsAtEnd] = useState('');


    const [turnover_at_start, setTurnoverAtstart] = useState('');
    const [pat_at_start, setPatAtStart] = useState('');
    const [der_at_start, setDerAtStart] = useState('');
    const [net_profit_sales_at_start, setNetProfitSalesAtStart] = useState('');
    const [current_ratio_at_start, setCurrentRatioAtStart] = useState('');
    const [net_worth_at_start, setNetWorthAtStart] = useState('');
    const [roi_at_start, setRoiAtStart] = useState('');
    const [revenue_per_employee_at_start, setRevenuePerEmployeeAtStart] = useState('');


    const [turnoverYear1, setTurnoverYear1] = useState('');
    const [patYear1, setPatYear1] = useState('');
    const [derYear1, setDerYear1] = useState('');
    const [netProfitSalesYear1, setNetProfitSalesYear1] = useState('');
    const [currentRatioYear1, setCurrentRatioYear1] = useState('');
    const [netWorthYear1, setNetWorthYear1] = useState('');
    const [roiYear1, setRoiYear1] = useState('');
    const [revenuePerEmployeeYear1, setRevenuePerEmployeeYear1] = useState('');

    const [turnoverYear2, setTurnoverYear2] = useState('');
    const [patYear2, setPatYear2] = useState('');
    const [derYear2, setDerYear2] = useState('');
    const [netProfitSalesYear2, setNetProfitSalesYear2] = useState('');
    const [currentRatioYear2, setCurrentRatioYear2] = useState('');
    const [netWorthYear2, setNetWorthYear2] = useState('');
    const [roiYear2, setRoiYear2] = useState('');
    const [revenuePerEmployeeYear2, setRevenuePerEmployeeYear2] = useState('');

    const [turnoverYear3, setTurnoverYear3] = useState('');
    const [patYear3, setPatYear3] = useState('');
    const [derYear3, setDerYear3] = useState('');
    const [netProfitSalesYear3, setNetProfitSalesYear3] = useState('');
    const [currentRatioYear3, setCurrentRatioYear3] = useState('');
    const [netWorthYear3, setNetWorthYear3] = useState('');
    const [roiYear3, setRoiYear3] = useState('');
    const [revenuePerEmployeeYear3, setRevenuePerEmployeeYear3] = useState('');
    const [commentsYear3, setCommentsYear3] = useState('');

    const [iso, setIso] = useState('');
    const [haccp, setHaccp] = useState('');
    const [whoGmpFda, setWhoGmpFda] = useState('');
    const [anyOther, setAnyOther] = useState('');
    const [orientation_comment, setOrientationComment] = useState('');

    const [increaseInTurnover, setIncreaseInTurnover] = useState('');
    const [increaseInProductivity, setIncreaseInProductivity] = useState('');
    const [increaseInQualityTools, setIncreaseInQualityTools] = useState('');
    const [increaseInAreasOfOperation, setIncreaseInAreasOfOperation] = useState('');
    const [introductionOfNewPractices, setIntroductionOfNewPractices] = useState('');
    const [innovationsDone, setInnovationsDone] = useState('');
    const [improveHrPractices, setImproveHrPractices] = useState('');
    const [anyTurnaroundActivity, setAnyTurnaroundActivity] = useState('');
    const [useOfInnovativeItPractices, setUseOfInnovativeItPractices] = useState('');
    const [developmentOfRdAndTechnology, setDevelopmentOfRdAndTechnology] = useState('');
    const [energyConservation, setEnergyConservation] = useState('');
    const [csrActivities, setCsrActivities] = useState('');
    const [receivedAnyRecognition, setReceivedAnyRecognition] = useState('');
    const [promotedAnyOtherUnits, setPromotedAnyOtherUnits] = useState('');
    const [comments, setComments] = useState('');

    const [nomineeForOrganisation, setNomineeForOrganisation] = useState('');
    const [contributionPerformance, setContributionPerformance] = useState('');
    const [eligibleForThisAward, setEligibleForThisAward] = useState('');
    const [date, setDate] = useState('');
    const [ceoMdName, setCeoMdName] = useState('');

    const handleChangee = (e) => {
        setNamek(e.target.value); // Update state when input value changes
    };

    const handleCheckboxChangep = (setter) => (event) => {
        setter(event.target.checked);
    };

    const handleCheckboxChangeao = (setter) => (event) => {
        setter(event.target.checked);
    };

    const handleCheckboxChangeso = (setter) => (event) => {
        setter(event.target.checked);
    };

    const handleChangel = (setter) => (event) => {
        setter(event.target.value);
    };

    const handleCheckboxChangeio = (e, setter) => {
        setter(e.target.checked);
    };

    const handleRadioChange = (setterFunction) => {
        setterFunction(true);
    };

    console.log('Name:', namek);
    console.log('Designation:', designationk);

    console.log("Form data before submission:", formData);

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Create a FormData object and append all the form values
        const formData = {
            name: namek,
            designation: designationk,
            age,
            technical_pg: technicalPg,
            technical_graduate: technicalGraduate,
            technical_others: technicalOthers,
            financial_pg: financialPg,
            financial_graduate: financialGraduate,
            financial_others: financialOthers,
            management_pg: managementPg,
            management_graduate: managementGraduate,
            management_others: managementOthers,
            professional_pg: professionalPg,
            professional_graduate: professionalGraduate,
            professional_others: professionalOthers,
            other_to_spe_pg: otherToSpePg,
            other_to_spe_graduate: otherToSpeGraduate,
            other_to_spe_others: otherToSpeOthers,

            exp_total_in_year: expTotalInYear,
            exp_in_same_line: expInSameLine,
            exp_in_same_org: expInSameOrg,
            is_nominee_chief_promoter: isNomineeChiefPromoter,
            is_nominee_first_generation: isNomineeFirstGeneration,
            business,
            industry,
            agriculture,
            service,
            other,
            family_background: family_background,

            traditional,
            existing,
            innovative,
            import_substitute: importSubstitute,
            product_service: product_Service,

            indigenous,
            own_rd: ownRd,
            imported,
            source_of_technology: source_of_technology,

            investment_in_rs_cr_at_start: investmentAtStart,
            term_loan_in_rs_cr_at_start: termLoanAtStart,
            turnover_in_rs_cr_at_start: turnoverAtStart,
            pbt_in_rs_cr_at_start: pbtAtStart,
            manpower_skilled_unskilled_at_start: manpowerAtStart,
            exports_in_rs_cr_at_start: exportsAtStart,
            investment_in_rs_cr_at_end: investmentAtEnd,
            term_loan_in_rs_cr_at_end: termLoanAtEnd,
            turnover_in_rs_cr_at_end: turnoverAtEnd,
            pbt_in_rs_cr_at_end: pbtAtEnd,
            manpower_skilled_unskilled_at_end: manpowerAtEnd,
            exports_in_rs_cr_at_end: exportsAtEnd,

            turnover_at_start: turnover_at_start,
            pat_at_start: pat_at_start,
            der_at_start: der_at_start,
            net_profit_sales_at_start: net_profit_sales_at_start,
            current_ratio_at_start: current_ratio_at_start,
            net_worth_at_start: net_worth_at_start,
            roi_at_start: roi_at_start,
            revenue_per_employee_at_start: revenue_per_employee_at_start,

            turnover_year_1: turnoverYear1,
            pat_year_1: patYear1,
            der_year_1: derYear1,
            net_profit_sales_year_1: netProfitSalesYear1,
            current_ratio_year_1: currentRatioYear1,
            net_worth_year_1: netWorthYear1,
            roi_year_1: roiYear1,
            revenue_per_employee_year_1: revenuePerEmployeeYear1,

            turnover_year_2: turnoverYear2,
            pat_year_2: patYear2,
            der_year_2: derYear2,
            net_profit_sales_year_2: netProfitSalesYear2,
            current_ratio_year_2: currentRatioYear2,
            net_worth_year_2: netWorthYear2,
            roi_year_2: roiYear2,
            revenue_per_employee_year_2: revenuePerEmployeeYear2,

            turnover_year_3: turnoverYear3,
            pat_year_3: patYear3,
            der_year_3: derYear3,
            net_profit_sales_year_3: netProfitSalesYear3,
            current_ratio_year_3: currentRatioYear3,
            net_worth_year_3: netWorthYear3,
            roi_year_3: roiYear3,
            revenue_per_employee_year_3: revenuePerEmployeeYear3,

            comments_year_3: commentsYear3,

            iso,
            haccp,
            who_gmp_fda: whoGmpFda,
            any_other: anyOther,
            orientation_comment: orientation_comment,

            increase_in_turnover: increaseInTurnover,
            increase_in_productivity: increaseInProductivity,
            increase_in_quality_tools: increaseInQualityTools,
            increase_in_areas_of_operation: increaseInAreasOfOperation,
            introduction_of_new_practices: introductionOfNewPractices,
            innovations_done: innovationsDone,
            improve_hr_practices: improveHrPractices,
            any_turnaround_activity: anyTurnaroundActivity,
            use_of_innovative_it_practices: useOfInnovativeItPractices,
            development_of_rd_and_technology: developmentOfRdAndTechnology,
            energy_conservation: energyConservation,
            csr_activities: csrActivities,
            received_any_recognition: receivedAnyRecognition,
            promoted_any_other_units: promotedAnyOtherUnits,
            comments,

            nominee_for_organisation: nomineeForOrganisation,
            contribution_performance: contributionPerformance,
            eligible_for_this_award: eligibleForThisAward,
            date,
            ceo_md_name: ceoMdName,
            form1_id,
            email
        };

        console.log('this is response', formData)

        axios.post('https://rvapi.emedha.in/pages/api/api/addEntrepreneur', formData)
            .then(response => {
                console.log('Success:', response.data);
                alert('Data inserted successfully');
                window.location.reload();
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Failed to insert data');
            });
    };


    return (
        <>
            <img src={H1} alt="item" className="img-fluid" style={{ height: '230px', width: '100%' }} />

            <div className='mt-4' style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                {[1, 2, 3].map((stepNumber) => (
                    <div
                        key={stepNumber} style={{ width: '60px', height: '30px', borderRadius: '10%', backgroundColor: formStep === stepNumber ? '#007bff' : '#ccc', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', cursor: formStep >= stepNumber ? 'pointer' : 'not-allowed', margin: '0 5px', opacity: formStep >= stepNumber ? 1 : 0.5, }}
                        onClick={() => { if (formStep >= stepNumber) { setFormStep(stepNumber); } }}>
                        {stepNumber}
                    </div>
                ))}
            </div>

            {formStep === 1 && (
                <div className='container'>
                    <h3 style={{ textAlign: 'center', marginBottom: '20px', textTransform: 'uppercase' }}>Declaration Form for Nominations</h3>
                    <form >
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegUser /> Name:</label>
                                <input type="text" name="name" placeholder="Enter Name" value={formData.name} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaRegBuilding /> Address:</label>
                                <input type="text" name="address" placeholder="Enter Address" value={formData.address} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaPhoneAlt /> Phone:</label>
                                <input type="text" name="phone" placeholder="Enter Phone" value={formData.phone} maxLength={10} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaEnvelope /> Email:</label>
                                <input type="email" name="email" placeholder="Enter Email" value={formData.email} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaPen /> Chief Promoter Name:</label>
                                <input type="text" name="chiefPromoter" placeholder="Enter Chief Promoter Name" value={formData.chiefPromoter} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPen /> Designation:</label>
                                <input type="text" name="designation" placeholder="Enter Designation" value={formData.designation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegFileAlt /> Year of Incorporation:</label>
                                <input type="text" name="yearOfIncorporation" value={formData.yearOfIncorporation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaRegFileAlt /> Areas of Operation:</label>
                                <input type="text" name="areasOfOperation" value={formData.areasOfOperation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> If selected, will you attend to the awards function to accept the award:</label>
                                <select name="attendAwards" value={formData.attendAwards} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> Are you willing to supplement any further information?</label>
                                <select name="willingToSupplement" value={formData.willingToSupplement} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> Are you willing to make a presentation before the jury?</label>
                                <select name="willingToPresent" value={formData.willingToPresent} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Write a brief 200-word write-up on why you consider yourself suitable for this Award:</label>
                            <textarea name="writeUp" value={formData.writeUp} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" required />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Any other relevant information in support of the proposal:</label>
                            <textarea name="otherInfo" value={formData.otherInfo} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaShieldAlt /> Legal & Statutory compliance:</label>
                            <div style={{ border: '2px solid #000', padding: '15px', borderRadius: '5px', backgroundColor: '#f8f9fa' }}>
                                <label>
                                    <input type="checkbox" name="statutoryApprovals" checked={formData.legalCompliance.statutoryApprovals} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Has all Statutory approvals
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noPFTaxLiabilities" checked={formData.legalCompliance.noPFTaxLiabilities} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> No PF/Tax liabilities
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noOffences" checked={formData.legalCompliance.noOffences} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Not involved in any Civil/Criminal/Economic offences
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="notNPA" checked={formData.legalCompliance.notNPA} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Not an NPA with Banks/FI
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noChildEmployment" checked={formData.legalCompliance.noChildEmployment} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> No Child employment
                                </label>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegUser /> Name of Applicant:</label>
                                <input type="text" name="applicantName" value={formData.applicantName} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPen /> Designation (CEO/MD/Chief Promoter):</label>
                                <input type="text" name="applicantDesignation" value={formData.applicantDesignation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaEnvelope /> Email ID:</label>
                                <input type="email" name="applicantEmail" value={formData.applicantEmail} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPhoneAlt /> Phone/Mobile:</label>
                                <input type="text" name="applicantPhone" value={formData.applicantPhone} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Signature of Applicant and Company seal:</label>
                            <input type="file" name="signature" accept="image/*" onChange={handleSignatureChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit1} className="btn btn-primary w-100">Submit</button>
                        </div>
                    </form>
                </div>
            )}

            {formStep === 2 && (
                <div className="container">
                    <form>
                        <h4 className='mt-2 mb-2 text-center'>FORM - 2</h4>
                        <p className='mb-0'>A. About the Organisation: (Write up in brief)</p>
                        <div className="mb-3">
                            <label htmlFor="organizationSnapshot" className="form-label">i. A snapshot of the Organisation, chief promoter, the key activities, challenges faced, competition, exports etc.</label>
                            <textarea value={snapshotOfOrganisation} onChange={(e) => setSnapshotOfOrganisation(e.target.value)} className="form-control" id="organizationSnapshot" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section ii */}
                        <div className="mb-3">
                            <label htmlFor="visionMission" className="form-label">ii. Vision, mission and policy of organization</label>
                            <textarea value={vision} onChange={(e) => setVision(e.target.value)} className="form-control" id="visionMission" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section iii */}
                        <div className="mb-3">
                            <label htmlFor="achievements" className="form-label">iii. Important achievements of Organisation in the past few years</label>
                            <textarea value={achievementsOfOrganisation} onChange={(e) => setAchievementsOfOrganisation(e.target.value)} className="form-control" id="achievements" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section iv */}
                        <div className="mb-3">
                            <label htmlFor="contribution" className="form-label">iv. Contribution to exchequer, society, CSR etc.</label>
                            <textarea value={contributionToExchequer} onChange={(e) => setContributionToExchequer(e.target.value)} className="form-control" id="contribution" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Size of Organisation */}
                        <h5>1. Size of Organisation: (investment in plant & machinery) in Rs Cr</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Below 10</td>
                                    <td><input type="radio" id="below10" name="size" value="below10" onChange={() => setSizeOfOrganisationBelow10('Below 10')} /></td>
                                </tr>
                                <tr>
                                    <td>B. 10 - 20</td>
                                    <td> <input type="radio" id="10to20" name="size" value="10to20" onChange={() => setSizeOfOrganisation10to20('10-20')} /></td>
                                </tr>
                                <tr>
                                    <td>C. 20 - 50</td>
                                    <td><input type="radio" id="20to50" name="size" value="20to50" onChange={() => setSizeOfOrganisation20to50('20-50')} /></td>
                                </tr>
                                <tr>
                                    <td>D. Above 50</td>
                                    <td> <input type="radio" id="above50" name="size" value="above50" onChange={() => setSizeOfOrganisationAbove50('Above 50')} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Ownership */}
                        <h5>2. Ownership (tick as applicable)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Sole Proprietor</td>
                                    <td> <input type="checkbox" id="soleProprietor" onChange={() => setOwnershipSoleProprietor(!ownershipSoleProprietor)} /></td>
                                </tr>
                                <tr>
                                    <td>B. Partnership Firm</td>
                                    <td> <input type="checkbox" id="partnershipFirm" onChange={() => setOwnershipPartnershipFirm(!ownershipPartnershipFirm)} /></td>
                                </tr>
                                <tr>
                                    <td>C. Private limited Company</td>
                                    <td> <input type="checkbox" id="privateLimitedCompany" onChange={() => setOwnershipPrivateLimitedCompany(!ownershipPrivateLimitedCompany)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Limited Company</td>
                                    <td> <input type="checkbox" id="limitedCompany" onChange={() => setOwnershipLimitedCompany(!ownershipLimitedCompany)} /></td>
                                </tr>
                                <tr>
                                    <td>E. Cooperative Society</td>
                                    <td> <input type="checkbox" id="cooperativeSociety" onChange={() => setOwnershipCooperativeSociety(!ownershipCooperativeSociety)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Sector */}
                        <h5>3. Sector (tick as applicable)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Private</td>
                                    <td>  <input type="checkbox" id="private" onChange={() => setSectorPrivate(!sectorPrivate)} /></td>
                                </tr>
                                <tr>
                                    <td>B. Public</td>
                                    <td> <input type="checkbox" id="public" onChange={() => setSectorPublic(!sectorPublic)} /></td>
                                </tr>
                                <tr>
                                    <td>C. Government - Central</td>
                                    <td> <input type="checkbox" id="governmentCentral" onChange={() => setSectorGovernmentCentral(!sectorGovernmentCentral)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Government - State</td>
                                    <td> <input type="checkbox" id="governmentState" onChange={() => setSectorGovernmentState(!sectorGovernmentState)} /></td>
                                </tr>
                                <tr>
                                    <td>E. Others</td>
                                    <td>  <input type="checkbox" id="others" onChange={() => setSectorOthers(!sectorOthers)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* No of Employees */}
                        <h5>4. No of Employees (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Less than 20</td>
                                    <td> <input type="checkbox" id="lessThan20" onChange={() => setNoOfEmployeesLessThan20(!noOfEmployeesLessThan20)} /></td>
                                </tr>
                                <tr>
                                    <td>B. 20 - 50</td>
                                    <td> <input type="checkbox" id="20to50Employees" onChange={() => setNoOfEmployees20to50(!noOfEmployees20to50)} /></td>
                                </tr>
                                <tr>
                                    <td>C. 50 - 100</td>
                                    <td> <input type="checkbox" id="50to100Employees" onChange={() => setNoOfEmployees50to100(!noOfEmployees50to100)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Above 100</td>
                                    <td> <input type="checkbox" id="above100Employees" onChange={() => setNoOfEmployeesAbove100(!noOfEmployeesAbove100)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Financial results for last 3 years */}
                        <h5>5. Financial results for last 3 years (As per Annual reports) (In Rs Cr)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Year</th>
                                    <th>Turnover</th>
                                    <th>Net Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>2021-22</td>
                                    <td>0-10</td>
                                    <td>   <input type="text" className="form-control" value={financialResults2021_22} onChange={(e) => setFinancialResults2021_22(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>2022-23</td>
                                    <td>10-50</td>
                                    <td> <input type="text" className="form-control" value={financialResults2022_23} onChange={(e) => setFinancialResults2022_23(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>2023-24</td>
                                    <td>50-100 & above</td>
                                    <td> <input type="text" className="form-control" value={financialResults2023_24} onChange={(e) => setFinancialResults2023_24(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Main Products/Services */}
                        <h5>6. Main Products/Services (Mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                    <th>Capacity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description1} onChange={(e) => setMainProductsServicesDescription1(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity1} onChange={(e) => setMainProductsServicesCapacity1(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description2} onChange={(e) => setMainProductsServicesDescription2(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity2} onChange={(e) => setMainProductsServicesCapacity2(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description3} onChange={(e) => setMainProductsServicesDescription3(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity3} onChange={(e) => setMainProductsServicesCapacity3(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <h5>7. Major facilities (mention details) (Fill relevant details based on type of your company)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Facility</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a</td>
                                    <td>Land area</td>
                                    <td><input type="text" className="form-control" value={major_facilities_land_area} onChange={(e) => setMajorFacilitiesLandArea(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>b</td>
                                    <td>Factory built up area</td>
                                    <td><input type="text" className="form-control" value={major_facilities_factory_built_up_area} onChange={(e) => setMajorFacilitiesFactoryBuiltUpArea(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>c</td>
                                    <td>Major Equipment</td>
                                    <td><input type="text" className="form-control" value={major_facilities_major_equipment} onChange={(e) => setMajorFacilitiesMajorEquipment(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>d</td>
                                    <td>Specialized Facility</td>
                                    <td><input type="text" className="form-control" value={major_facilities_specialized_facility} onChange={(e) => setMajorFacilitiesSpecializedFacility(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>e</td>
                                    <td>Services</td>
                                    <td><input type="text" className="form-control" value={major_facilities_services} onChange={(e) => setMajorFacilitiesServices(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <h5>8. Technology adopted (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Traditional</td>
                                    <td><input type="checkbox" checked={technology_adopted_traditional} onChange={(e) => setTechnologyAdoptedTraditional(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Indigenous</td>
                                    <td><input type="checkbox" checked={technology_adopted_indigenous} onChange={(e) => setTechnologyAdoptedIndigenous(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. In house R & D</td>
                                    <td><input type="checkbox" checked={technology_adopted_in_house_r_d} onChange={(e) => setTechnologyAdoptedInHouseRD(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. Foreign Technology</td>
                                    <td><input type="checkbox" checked={technology_adopted_foreign_technology} onChange={(e) => setTechnologyAdoptedForeignTechnology(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>e. Franchise</td>
                                    <td><input type="checkbox" checked={technology_adopted_franchise} onChange={(e) => setTechnologyAdoptedFranchise(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={technology_adopted_comment} onChange={(e) => setTechnologyAdoptedComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />


                        {/* Quality Compliance */}
                        <h5>9. Quality Compliance (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. ISO</td>
                                    <td><input type="checkbox" checked={quality_compliance_iso} onChange={(e) => setQualityComplianceIso(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. BIS</td>
                                    <td><input type="checkbox" checked={quality_compliance_bis} onChange={(e) => setQualityComplianceBis(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. GMP/WHO/FDA/HACCP</td>
                                    <td><input type="checkbox" checked={quality_compliance_gmp_who_fda_haccp} onChange={(e) => setQualityComplianceGmpWhoFdaHaccp(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. Any other, to mention</td>
                                    <td><input type="checkbox" checked={quality_compliance_other} onChange={(e) => setQualityComplianceOther(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={quality_compliance_comment} onChange={(e) => setQualityComplianceComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        <h5>10. Management Functions – Has (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Human Resources Department</td>
                                    <td><input type="checkbox" checked={management_functions_human_resources_department} onChange={(e) => setManagementFunctionsHumanResourcesDepartment(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Finance & Accounts</td>
                                    <td><input type="checkbox" checked={management_functions_finance_accounts} onChange={(e) => setManagementFunctionsFinanceAccounts(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. Marketing/ Business Development</td>
                                    <td><input type="checkbox" checked={management_functions_marketing_business_development} onChange={(e) => setManagementFunctionsMarketingBusinessDevelopment(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. R & D</td>
                                    <td><input type="checkbox" checked={management_functions_r_d} onChange={(e) => setManagementFunctionsRD(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>e. Internal Audit</td>
                                    <td><input type="checkbox" checked={management_functions_internal_audit} onChange={(e) => setManagementFunctionsInternalAudit(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>f. Quality Assurance</td>
                                    <td><input type="checkbox" checked={management_functions_quality_assurance} onChange={(e) => setManagementFunctionsQualityAssurance(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>g. Any other, please specify</td>
                                    <td><input type="checkbox" checked={management_functions_other} onChange={(e) => setManagementFunctionsOther(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={management_functions_comment} onChange={(e) => setManagementFunctionsComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        <h5>12. Level of IT intervention (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Use of ERP</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_use_of_erp} onChange={(e) => setLevelOfITInterventionUseOfERP(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Customized software</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_customized_software} onChange={(e) => setLevelOfITInterventionCustomizedSoftware(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. General office solutions</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_general_office_solutions} onChange={(e) => setLevelOfITInterventionGeneralOfficeSolutions(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. No IT facility</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_no_it_facility} onChange={(e) => setLevelOfITInterventionNoITFacility(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={level_of_it_intervention_comment} onChange={(e) => setLevelOfITInterventionComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        {/* In receipt of any Award */}
                        <h5>13. In receipt of any Award/recognition of repute</h5>
                        <div className="mb-3">
                            <label className="form-label">YES/NO</label>
                            <div>
                                <input type="radio" name="award" checked={award_recognition_yes} onChange={() => setAwardRecognitionYes(true)} /> YES
                                <input type="radio" name="award" checked={award_recognition_no} onChange={() => setAwardRecognitionNo(true)} /> NO
                            </div>
                            <textarea className="form-control mt-2" rows="3" value={award_recognition_comment} onChange={(e) => setAwardRecognitionComment(e.target.value)} placeholder="If yes, to mention details" style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Strategic Plan */}
                        <h5>14. Does the Organization have a Strategic Plan for future growth</h5>
                        <div className="mb-3">
                            <label className="form-label">YES/NO</label>
                            <div>
                                <input type="radio" name="strategicPlan" checked={strategic_plan_for_future_yes} onChange={() => setStrategicPlanForFutureYes(true)} /> YES
                                <input type="radio" name="strategicPlan" checked={strategic_plan_for_future_no} onChange={() => setStrategicPlanForFutureNo(true)} /> NO
                            </div>
                            <textarea className="form-control mt-2" rows="3" value={strategic_plan_for_future_comment} onChange={(e) => setStrategicPlanForFutureComment(e.target.value)} placeholder="If yes, mention details" style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* About Product/Service */}
                        <h3>A. About Product/ Service:</h3>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Description of product / service</td>
                                    <td><input type="text" className="form-control" value={about_product_service_description} onChange={(e) => setAboutProductServiceDescription(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Capacity</td>
                                    <td><input type="text" className="form-control" value={about_product_service_capacity} onChange={(e) => setAboutProductServiceCapacity(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Features of product</td>
                                    <td><input type="text" className="form-control" value={about_product_service_features} onChange={(e) => setAboutProductServiceFeatures(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Uniqueness, if any</td>
                                    <td><input type="text" className="form-control" value={about_product_service_uniqueness} onChange={(e) => setAboutProductServiceUniqueness(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Market</td>
                                    <td><input type="text" className="form-control" value={about_product_service_market} onChange={(e) => setAboutProductServiceMarket(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>Export content in Turnover</td>
                                    <td><input type="text" className="form-control" value={about_product_service_export_content_in_turnover} onChange={(e) => setAboutProductServiceExportContentInTurnover(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* About Chief Promoter */}
                        <h3>B. About Chief Promoter:</h3>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Educational qualification</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_educational_qualification} onChange={(e) => setAboutChiefPromoterEducationalQualification(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Experience in line</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_experience_in_line} onChange={(e) => setAboutChiefPromoterExperienceInLine(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Are you first generation entrepreneur?</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_first_generation_entrepreneur} onChange={(e) => setAboutChiefPromoterFirstGenerationEntrepreneur(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Contribution to the Organization</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_contribution_to_organisation} onChange={(e) => setAboutChiefPromoterContributionToOrganisation(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Any relevant details, to specify</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_relevant_details} onChange={(e) => setAboutChiefPromoterRelevantDetails(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="mb-3">
                            <label className="form-label">Signature:</label>
                            <input value={signatureUrl} onChange={(e) => setSignatureUrl(e.target.value)} type="file" className="form-control" placeholder="Signature" style={{ border: '2px solid #000' }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Name:</label>
                            <input value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control" placeholder="Name" style={{ border: '2px solid #000' }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Designation:</label>
                            <input value={designation} onChange={(e) => setDesignation(e.target.value)} type="text" className="form-control" placeholder="Designation" style={{ border: '2px solid #000' }} />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit2} className="btn btn-primary w-100">Submit</button>
                        </div>

                        <p><strong>(To be signed by CEO/MD of Organization)</strong></p>

                    </form>
                </div>
            )}

            {formStep === 3 && (
                <div className="container mt-5">
                    <h2 className="text-center">Form 3 - ENTREPRENEUR OF THE YEAR</h2>
                    <form >

                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">Name</label>
                            <input
                                type="text"
                                className="form-control"

                                name="name"
                                value={namek}
                                onChange={handleChangee}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        {/* Designation */}
                        <div className="mb-3">
                            <label htmlFor="designation" className="form-label">Designation</label>
                            <input
                                type="text"
                                className="form-control"

                                name="designation"
                                value={designationk}
                                onChange={(e) => setDesignationk(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        {/* Age */}
                        <div className="mb-3">
                            <label htmlFor="age" className="form-label">Age</label>
                            <input
                                type="number"
                                className="form-control"
                                name="age"
                                value={age}
                                onChange={(e) => setAge(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        {/* 3. Qualification */}
                        <h5>3. Qualification (mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Discipline</th>
                                    <th>PG</th>
                                    <th>Graduate</th>
                                    <th>Other, to specify</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Technical</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={technicalPg}
                                            onChange={(e) => setTechnicalPg(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={technicalGraduate}
                                            onChange={(e) => setTechnicalGraduate(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={technicalOthers}
                                            onChange={(e) => setTechnicalOthers(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Financial</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={financialPg}
                                            onChange={(e) => setFinancialPg(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={financialGraduate}
                                            onChange={(e) => setFinancialGraduate(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={financialOthers}
                                            onChange={(e) => setFinancialOthers(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Management</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={managementPg}
                                            onChange={(e) => setManagementPg(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={managementGraduate}
                                            onChange={(e) => setManagementGraduate(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={managementOthers}
                                            onChange={(e) => setManagementOthers(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Professional</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={professionalPg}
                                            onChange={(e) => setProfessionalPg(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={professionalGraduate}
                                            onChange={(e) => setProfessionalGraduate(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={professionalOthers}
                                            onChange={(e) => setProfessionalOthers(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Other</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={otherToSpePg}
                                            onChange={(e) => setOtherToSpePg(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={otherToSpeGraduate}
                                            onChange={(e) => setOtherToSpeGraduate(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={otherToSpeOthers}
                                            onChange={(e) => setOtherToSpeOthers(e.target.value)}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* 4. Experience */}
                        <h5>4. Experience (mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Attribute</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Total (in Years)	In same line	In same Organisation</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="experience.totalYears"
                                            value={expTotalInYear}
                                            onChange={(e) => setExpTotalInYear(e.target.value)} // Updates state
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>In same line</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="experience.inSameOrganisation"
                                            value={expInSameLine}
                                            onChange={(e) => setExpInSameLine(e.target.value)} // Updates state
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>In Same Organisation</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="experience.inSameOrganisation"
                                            value={expInSameOrg}
                                            onChange={(e) => setExpInSameOrg(e.target.value)} // Updates state
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* 5. Is nominee Chief Promotor */}
                        <div className="mb-3">
                            <h5>5. Is nominee Chief Promotor?</h5>
                            <input
                                style={{ border: '2px solid #000' }}
                                type="text"
                                className="form-control"
                                id="chiefPromotor"
                                name="chiefPromotor"
                                value={isNomineeChiefPromoter}
                                onChange={(e) => setIsNomineeChiefPromoter(e.target.value)} // Update state
                            />
                        </div>

                        {/* Is nominee a first-generation entrepreneur */}
                        <div className="mb-3">
                            <h5>6. Is nominee a first-generation entrepreneur?</h5>
                            <input
                                style={{ border: '2px solid #000' }}
                                type="text"
                                className="form-control"
                                id="firstGenerationEntrepreneur"
                                name="firstGenerationEntrepreneur"
                                value={isNomineeFirstGeneration}
                                onChange={(e) => setIsNomineeFirstGeneration(e.target.value)} // Update state
                            />
                        </div>

                        {/* 7. Family background */}
                        <h5>7. Family background (tick appropriately)</h5>
                        <div>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Business</th>
                                        <th>Industry</th>
                                        <th>Agriculture</th>
                                        <th>Service</th>
                                        <th>Other</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="familyBackground.business"
                                                checked={business}
                                                onChange={handleCheckboxChangep(setBusiness)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="familyBackground.industry"
                                                checked={industry}
                                                onChange={handleCheckboxChangep(setIndustry)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="familyBackground.agriculture"
                                                checked={agriculture}
                                                onChange={handleCheckboxChangep(setAgriculture)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="familyBackground.service"
                                                checked={service}
                                                onChange={handleCheckboxChangep(setService)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="familyBackground.other"
                                                checked={other}
                                                onChange={handleCheckboxChangep(setOther)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className='mb-0'>Details in brief:</p>
                            <input
                                style={{ border: '2px solid #000' }}
                                type="text"
                                className="form-control"
                                value={family_background}
                                onChange={(e) => setFamilyBacgroumd(e.target.value)}
                            />
                        </div>

                        {/* 8. About Product / Service */}
                        <h5 className="mt-2">8. About Product / Service (tick appropriately)</h5>
                        <div>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Traditional</th>
                                        <th>Existing</th>
                                        <th>Innovative</th>
                                        <th>Import Substitute</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="productService.traditional"
                                                checked={traditional}
                                                onChange={handleCheckboxChangeao(setTraditional)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="productService.existing"
                                                checked={existing}
                                                onChange={handleCheckboxChangeao(setExisting)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="productService.innovative"
                                                checked={innovative}
                                                onChange={handleCheckboxChangeao(setInnovative)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="productService.importSubstitute"
                                                checked={importSubstitute}
                                                onChange={handleCheckboxChangeao(setImportSubstitute)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="mb-0">Details in brief:</p>
                            <input
                                style={{ border: '2px solid #000' }}
                                type="text"
                                className="form-control"
                                value={product_Service}
                                onChange={(e) => setProductService(e.target.value)}
                            />
                        </div>

                        {/* 9. Source of Technology */}
                        <h5 className="mt-2">9. Source of Technology (tick appropriately)</h5>
                        <div>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Indigenous</th>
                                        <th>Own R&D</th>
                                        <th>Imported</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="technologySource.indigenous"
                                                checked={indigenous}
                                                onChange={handleCheckboxChangeso(setIndigenous)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="technologySource.ownRAndD"
                                                checked={ownRd}
                                                onChange={handleCheckboxChangeso(setOwnRd)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="technologySource.imported"
                                                checked={imported}
                                                onChange={handleCheckboxChangeso(setImported)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="mb-0">Details in brief:</p>
                            <input
                                style={{ border: '2px solid #000' }}
                                type="text"
                                className="form-control"
                                value={source_of_technology}
                                onChange={(e) => setSourceOfTechnology(e.target.value)}
                            />
                        </div>

                        {/* 10. Size of Unit */}
                        <h5 className="mt-2">10. Size of Unit</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Attribute</th>
                                    <th>At start (1st year of operation)</th>
                                    <th>At end of the last FY</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Investment in Rs Cr</td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.investmentStart"
                                            value={investmentAtStart}
                                            onChange={handleChangel(setInvestmentAtStart)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.investmentEnd"
                                            value={investmentAtEnd}
                                            onChange={handleChangel(setInvestmentAtEnd)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Term Loan in Rs Cr</td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.termLoanStart"
                                            value={termLoanAtStart}
                                            onChange={handleChangel(setTermLoanAtStart)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.termLoanEnd"
                                            value={termLoanAtEnd}
                                            onChange={handleChangel(setTermLoanAtEnd)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Turnover in Rs Cr</td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.turnoverStart"
                                            value={turnoverAtStart}
                                            onChange={handleChangel(setTurnoverAtStart)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.turnoverEnd"
                                            value={turnoverAtEnd}
                                            onChange={handleChangel(setTurnoverAtEnd)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>PBT in Rs Cr</td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.pbtStart"
                                            value={pbtAtStart}
                                            onChange={handleChangel(setPbtAtStart)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.pbtEnd"
                                            value={pbtAtEnd}
                                            onChange={handleChangel(setPbtAtEnd)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Manpower: Skilled + unskilled</td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.manpowerStart"
                                            value={manpowerAtStart}
                                            onChange={handleChangel(setManpowerAtStart)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.manpowerEnd"
                                            value={manpowerAtEnd}
                                            onChange={handleChangel(setManpowerAtEnd)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Exports in Rs Cr</td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.exportsStart"
                                            value={exportsAtStart}
                                            onChange={handleChangel(setExportsAtStart)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="unitSize.exportsEnd"
                                            value={exportsAtEnd}
                                            onChange={handleChangel(setExportsAtEnd)}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* 11. Financial Indicators */}
                        <div>
                            <h5 className='mt-2'>11. Financial Indicators (last 3 years)</h5>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Attribute/Year</th>
                                        <th>At start - 1st year of operation</th>
                                        <th>Year 1 (2022-23)</th>
                                        <th>Year 2 (2023-24)</th>
                                        <th>Year 3 (2024-25)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Turnover</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.turnoverStart"
                                                value={turnover_at_start}
                                                onChange={(e) => setTurnoverAtstart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.turnoverYear1"
                                                value={turnoverYear1}
                                                onChange={(e) => setTurnoverYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.turnoverYear2"
                                                value={turnoverYear2}
                                                onChange={(e) => setTurnoverYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.turnoverYear3"
                                                value={turnoverYear3}
                                                onChange={(e) => setTurnoverYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>PAT</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.patStart"
                                                value={pat_at_start}
                                                onChange={(e) => setPatAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.patYear1"
                                                value={patYear1}
                                                onChange={(e) => setPatYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.patYear2"
                                                value={patYear2}
                                                onChange={(e) => setPatYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.patYear3"
                                                value={patYear3}
                                                onChange={(e) => setPatYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>DER</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.derStart"
                                                value={der_at_start}
                                                onChange={(e) => setDerAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.derYear1"
                                                value={derYear1}
                                                onChange={(e) => setDerYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.derYear2"
                                                value={derYear2}
                                                onChange={(e) => setDerYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.derYear3"
                                                value={derYear3}
                                                onChange={(e) => setDerYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Net Profit/sales</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.netProfitSalesStart"
                                                value={net_profit_sales_at_start}
                                                onChange={(e) => setNetProfitSalesAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.netProfitSalesYear1"
                                                value={netProfitSalesYear1}
                                                onChange={(e) => setNetProfitSalesYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.netProfitSalesYear2"
                                                value={netProfitSalesYear2}
                                                onChange={(e) => setNetProfitSalesYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.netProfitSalesYear3"
                                                value={netProfitSalesYear3}
                                                onChange={(e) => setNetProfitSalesYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Current ratio</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.currentRatioStart"
                                                value={current_ratio_at_start}
                                                onChange={(e) => setCurrentRatioAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.currentRatioYear1"
                                                value={currentRatioYear1}
                                                onChange={(e) => setCurrentRatioYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.currentRatioYear2"
                                                value={currentRatioYear2}
                                                onChange={(e) => setCurrentRatioYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.currentRatioYear3"
                                                value={currentRatioYear3}
                                                onChange={(e) => setCurrentRatioYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Net worth</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.netWorthStart"
                                                value={net_worth_at_start}
                                                onChange={(e) => setNetWorthAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.netWorthYear1"
                                                value={netWorthYear1}
                                                onChange={(e) => setNetWorthYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.netWorthYear2"
                                                value={netWorthYear2}
                                                onChange={(e) => setNetWorthYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.netWorthYear3"
                                                value={netWorthYear3}
                                                onChange={(e) => setNetWorthYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>ROI</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.roiStart"
                                                value={roi_at_start}
                                                onChange={(e) => setRoiAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.roiYear1"
                                                value={roiYear1}
                                                onChange={(e) => setRoiYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.roiYear2"
                                                value={roiYear2}
                                                onChange={(e) => setRoiYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.roiYear3"
                                                value={roiYear3}
                                                onChange={(e) => setRoiYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Revenue per employee</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.revenuePerEmployeeStart"
                                                value={revenue_per_employee_at_start}
                                                onChange={(e) => setRevenuePerEmployeeAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.revenuePerEmployeeYear1"
                                                value={revenuePerEmployeeYear1}
                                                onChange={(e) => setRevenuePerEmployeeYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.revenuePerEmployeeYear2"
                                                value={revenuePerEmployeeYear2}
                                                onChange={(e) => setRevenuePerEmployeeYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="financialIndicators.revenuePerEmployeeYear3"
                                                value={revenuePerEmployeeYear3}
                                                onChange={(e) => setRevenuePerEmployeeYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className='mb-0'>Comments, if any:</p>
                            <textarea
                                className="form-control"
                                name="financialIndicators.comments"
                                value={commentsYear3}
                                onChange={(e) => setCommentsYear3(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>


                        {/* 12. Quality Orientation */}
                        <div>
                            <h5 className='mt-2'>12. Orientation for quality: (as applicable)</h5>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>ISO</th>
                                        <th>HACCP</th>
                                        <th>WHO/GMP/FDA</th>
                                        <th>Any other</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="qualityOrientation.iso"
                                                checked={iso}
                                                onChange={(e) => handleCheckboxChangeio(e, setIso)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="qualityOrientation.haccp"
                                                checked={haccp}
                                                onChange={(e) => handleCheckboxChangeio(e, setHaccp)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="qualityOrientation.whoGMPFDA"
                                                checked={whoGmpFda}
                                                onChange={(e) => handleCheckboxChangeio(e, setWhoGmpFda)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="qualityOrientation.other"
                                                checked={anyOther}
                                                onChange={(e) => handleCheckboxChangeio(e, setAnyOther)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className='mb-0'>Comments, if any:</p>
                            <textarea
                                className="form-control"
                                name="financialIndicators.comments"
                                style={{ border: '2px solid #000' }}
                                value={orientation_comment}
                                onChange={(e) => setOrientationComment(e.target.value)}
                            />
                        </div>

                        <div className="mb-3">
                            <FaBriefcase /> <label htmlFor="qualityComments" className="form-label">Contribution of nominee for Organisation:( a brief on each of following, as applicable)</label>

                            {/* Radio buttons for different contributions */}
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="increaseTurnover"
                                    style={{ border: '2px solid #000' }}
                                    checked={increaseInTurnover}
                                    onChange={() => handleRadioChange(setIncreaseInTurnover)}
                                />
                                <label className="form-check-label" htmlFor="increaseTurnover">Increase in turnover</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="increaseProductivity"
                                    style={{ border: '2px solid #000' }}
                                    checked={increaseInProductivity}
                                    onChange={() => handleRadioChange(setIncreaseInProductivity)}
                                />
                                <label className="form-check-label" htmlFor="increaseProductivity">Increase in productivity</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="increaseQuality"
                                    style={{ border: '2px solid #000' }}
                                    checked={increaseInQualityTools}
                                    onChange={() => handleRadioChange(setIncreaseInQualityTools)}
                                />
                                <label className="form-check-label" htmlFor="increaseQuality">Increase in quality/use of quality tools</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="increaseAreas"
                                    style={{ border: '2px solid #000' }}
                                    checked={increaseInAreasOfOperation}
                                    onChange={() => handleRadioChange(setIncreaseInAreasOfOperation)}
                                />
                                <label className="form-check-label" htmlFor="increaseAreas">Increase in areas of operation</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="newPractices"
                                    style={{ border: '2px solid #000' }}
                                    checked={introductionOfNewPractices}
                                    onChange={() => handleRadioChange(setIntroductionOfNewPractices)}
                                />
                                <label className="form-check-label" htmlFor="newPractices">Introduction of new practices</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="innovations"
                                    style={{ border: '2px solid #000' }}
                                    checked={innovationsDone}
                                    onChange={() => handleRadioChange(setInnovationsDone)}
                                />
                                <label className="form-check-label" htmlFor="innovations">Innovations done</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="hrPractices"
                                    style={{ border: '2px solid #000' }}
                                    checked={improveHrPractices}
                                    onChange={() => handleRadioChange(setImproveHrPractices)}
                                />
                                <label className="form-check-label" htmlFor="hrPractices">Improve HR practices</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="turnAround"
                                    style={{ border: '2px solid #000' }}
                                    checked={anyTurnaroundActivity}
                                    onChange={() => handleRadioChange(setAnyTurnaroundActivity)}
                                />
                                <label className="form-check-label" htmlFor="turnAround">Any turnaround activity</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="itPractices"
                                    style={{ border: '2px solid #000' }}
                                    checked={useOfInnovativeItPractices}
                                    onChange={() => handleRadioChange(setUseOfInnovativeItPractices)}
                                />
                                <label className="form-check-label" htmlFor="itPractices">Use of innovative IT practices/MIS</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="researchDevelopment"
                                    style={{ border: '2px solid #000' }}
                                    checked={developmentOfRdAndTechnology}
                                    onChange={() => handleRadioChange(setDevelopmentOfRdAndTechnology)}
                                />
                                <label className="form-check-label" htmlFor="researchDevelopment">Development of R & D and use of the technology</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="energyConservation"
                                    style={{ border: '2px solid #000' }}
                                    checked={energyConservation}
                                    onChange={() => handleRadioChange(setEnergyConservation)}
                                />
                                <label className="form-check-label" htmlFor="energyConservation">Energy conservation</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="csrActivities"
                                    style={{ border: '2px solid #000' }}
                                    checked={csrActivities}
                                    onChange={() => handleRadioChange(setCsrActivities)}
                                />
                                <label className="form-check-label" htmlFor="csrActivities">CSR activities</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="recognitionAwards"
                                    style={{ border: '2px solid #000' }}
                                    checked={receivedAnyRecognition}
                                    onChange={() => handleRadioChange(setReceivedAnyRecognition)}
                                />
                                <label className="form-check-label" htmlFor="recognitionAwards">Received any Recognition/awards of repute</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="contribution"
                                    id="promotedOtherUnits"
                                    style={{ border: '2px solid #000' }}
                                    checked={promotedAnyOtherUnits}
                                    onChange={() => handleRadioChange(setPromotedAnyOtherUnits)}
                                />
                                <label className="form-check-label" htmlFor="promotedOtherUnits">Promoted any other units</label>
                            </div>

                            {/* Comments textarea */}
                            <textarea
                                className="form-control"
                                id="qualityComments"
                                name="qualityOrientation.comments"
                                value={comments}
                                onChange={(e) => setComments(e.target.value)} // update comments state
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        {/* 13. Contributions */}
                        <div className="mb-3">
                            <label htmlFor="contributions" className="form-label">Contribution of nominee for Organisation:</label>
                            <textarea
                                style={{ border: '2px solid #000' }}
                                className="form-control"
                                id="contributions"
                                name="contributions"
                                value={nomineeForOrganisation} // bind state to the textarea
                                onChange={(e) => setNomineeForOrganisation(e.target.value)} // update state
                            />
                        </div>

                        {/* 14. Significant Performance */}
                        <div className="mb-3">
                            <label htmlFor="significantPerformance" className="form-label">Any contribution/performance, which can be said as significant:</label>
                            <textarea
                                style={{ border: '2px solid #000' }}
                                className="form-control"
                                id="significantPerformance"
                                name="significantPerformance"
                                value={contributionPerformance} // bind state to the textarea
                                onChange={(e) => setContributionPerformance(e.target.value)} // update state
                            />
                        </div>

                        {/* 15. Award Reason */}
                        <div className="mb-3">
                            <label htmlFor="awardReason" className="form-label">Write in 200 words as why you consider eligible for this award</label>
                            <textarea
                                style={{ border: '2px solid #000' }}
                                className="form-control"
                                id="awardReason"
                                name="awardReason"
                                value={eligibleForThisAward} // bind state to the textarea
                                onChange={(e) => setEligibleForThisAward(e.target.value)} // update state
                            />
                        </div>

                        {/* 16. Signature */}
                        <div className="mb-3">
                            <label htmlFor="signatureDate" className="form-label">Date</label>
                            <input
                                style={{ border: '2px solid #000' }}
                                type="date"
                                className="form-control"
                                id="signatureDate"
                                name="signatureDate"
                                value={date} // bind state to the input field
                                onChange={(e) => setDate(e.target.value)} // update state
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="ceoName" className="form-label">Name of CEO/MD</label>
                            <input
                                style={{ border: '2px solid #000' }}
                                type="text"
                                className="form-control"
                                id="ceoName"
                                name="ceoName"
                                value={ceoMdName} // binding state to the input value
                                onChange={(e) => setCeoMdName(e.target.value)} // directly updating state
                            />
                        </div>

                        <button onClick={handleSubmit} type="submit" className="btn btn-primary mt-4">Submit</button>
                    </form>
                </div>
            )}

            <footer style={{ backgroundColor: '#f1f1f1', padding: '20px 0', textAlign: 'center', marginTop: 'auto' }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px', }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>
        </>
    );
};

export default Form3f12;
